import type { CoreApiClient } from "../client";
import type {
  AddGroupUserRequestBody,
  CreateGroupRequestBody,
  MoveBuildingRequestBody,
  UpdateGroupRequestBody,
  UpdateGroupUserRequestBody,
} from "../types/group.type";

export const createGroupMutations = (api: CoreApiClient) => {
  const { request } = api;

  const create = async (body: CreateGroupRequestBody) => {
    const { data } = await request("post", "/groups", {
      body,
    });
    return data;
  };

  const update = async (groupId: string, body: UpdateGroupRequestBody) => {
    const { data } = await request("patch", "/groups/{groupId}", {
      params: { path: { groupId } },
      body,
    });
    return data;
  };

  const deleteGroup = async (groupId: string) => {
    const { data } = await request("delete", "/groups/{groupId}", {
      params: { path: { groupId } },
    });
    return data;
  };

  const moveBuilding = async (groupId: string, body: MoveBuildingRequestBody) => {
    const { data } = await request("post", "/groups/{groupId}/buildings", {
      params: { path: { groupId } },
      body,
    });
    return data;
  };

  const updateUser = async (groupId: string, userId: string, body: UpdateGroupUserRequestBody) => {
    const { data } = await request("patch", "/groups/{groupId}/users/{userId}", {
      params: { path: { groupId, userId } },
      body,
    });
    return data;
  };

  const removeUser = async (groupId: string, userId: string) => {
    const { data } = await request("delete", "/groups/{groupId}/users/{userId}", {
      params: { path: { groupId, userId } },
    });
    return data;
  };

  const addUser = async (groupId: string, body: AddGroupUserRequestBody) => {
    const { data } = await request("post", "/groups/{groupId}/users", {
      params: { path: { groupId } },
      body,
    });
    return data;
  };

  return {
    create,
    update,
    delete: deleteGroup,
    moveBuilding,
    updateUser,
    removeUser,
    addUser,
  };
};
